var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67523 19.4224C9.36251 19.7393 8.85034 19.7371 8.54042 19.4174C8.24004 19.1076 8.24222 18.6145 8.54533 18.3074L14.7697 12L8.54533 5.69261C8.24223 5.38546 8.24004 4.89241 8.54042 4.58259C8.85034 4.26294 9.36251 4.26067 9.67523 4.57757L17 12L9.67523 19.4224Z",
    fill: "#393D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.e56940f9af4a7b8e97a2f1505150593f.svg";
export { ForwardRef as ReactComponent };